import type { RouteLocationRaw } from '#vue-router'
import type { NavigateToOptions } from '#app/composables/router'

export default () => {
  const localePath = useLocalePath()
  const currentShop = useCurrentShop()

  const toLocalePath = (route: RouteLocationRaw): string => {
    if (typeof route !== 'string') {
      return localePath(route)
    }

    const normalizedPath = normalizePathRoute(route)
    return hasLocalePrefix(normalizedPath, currentShop.value?.path)
      ? normalizedPath
      : localePath(normalizedPath)
  }

  const localizedNavigateTo = (
    route: RouteLocationRaw,
    options?: NavigateToOptions,
  ) => {
    if (typeof route !== 'string') {
      return navigateTo(localePath(route), options)
    }

    const normalizedPath = normalizePathRoute(route)
    const dedupedLocalePath = hasLocalePrefix(
      normalizedPath,
      currentShop.value?.path,
    )
      ? normalizedPath
      : localePath(normalizedPath)

    return navigateTo(dedupedLocalePath, options)
  }

  return {
    localizedNavigateTo,
    toLocalePath,
  }
}
